import React from "react";
import { Typography, Button, Box } from "@mui/material";

export default function FormUserRegisterButton() {
  return (
    <Box textAlign="center">
      <Button
        type="submit"
        variant="contained"
        sx={{
          color: "white",
          fontSize: "14px",
          fontWeight: "bold",
          backgroundColor: "#28345e",
          borderRadius: "25px",
          py: "10px",
          px: "20px",
          width: "100%",
          "&:hover": {
            background: "#8bb6c6",
          },
        }}
      >
        <Typography fontWeight="bold">追加</Typography>
      </Button>
    </Box>
  );
}